<script setup lang="ts">
import { computed } from 'vue';
import HugeIcon from '../HugeIcon/HugeIcon.vue';
import TTooltip from '../TTooltip.vue';
import type { EvaluationTaskTypeIconProps } from './evaluation-icon';
import {
  evaluationIconDimensions,
  evaluationIconStateStyles,
  evaluationTaskTypeIconStyles,
  evaluationTaskTypeIcons,
} from './evaluation-icon';

const props = withDefaults(defineProps<EvaluationTaskTypeIconProps>(), {
  size: 'md',
  tooltipPlacement: 'top',
});

const dimensions = computed(() => evaluationIconDimensions[props.size]);
const taskIcon = computed(() => evaluationTaskTypeIcons[props.taskType]);
const containerClasses = computed(() =>
  props.state
    ? evaluationIconStateStyles[props.state].container
    : evaluationTaskTypeIconStyles.container,
);
</script>

<template>
  <TTooltip :content="props.tooltip" :placement="props.tooltipPlacement">
    <span
      class="inline-flex shrink-0"
      :class="dimensions.taskTypeIconWrapper"
      role="img"
      :aria-label="props.ariaLabel"
    >
      <span class="relative shrink-0" :class="dimensions.container">
        <span
          class="flex size-full items-center justify-center rounded-full"
          :class="containerClasses"
        >
          <HugeIcon :icon="taskIcon" :size="dimensions.iconSize" />
        </span>
        <span
          v-if="props.number != null"
          class="absolute inline-flex items-center justify-center rounded-full bg-transparent leading-none font-semibold"
          :class="[
            dimensions.numberBadge,
            dimensions.numberBadgePosition,
            evaluationTaskTypeIconStyles.numberBadgeText,
          ]"
          aria-hidden="true"
        >
          {{ props.number }}
        </span>
      </span>
    </span>
  </TTooltip>
</template>
